module.exports = __webpack_public_path__ + "img/home-rugby-icon-red.22d705db.png";